import type { Locale } from 'antd/es/locale';
import locale from 'antd/es/locale/en_US';
import { mergeDeepRight } from 'ramda';

// NOTE: Add translations for what you are missing or want to customize.
// Default translations can be found here: node_modules\antd\lib\locale\default.js

export const enUS: Locale = mergeDeepRight(locale, {
  Form: {
    defaultValidateMessages: {
      types: {
        email: 'Email is not valid',
      },
    },
  },
  Pagination: {
    items_per_page: 'records',
  },
  DatePicker: {
    lang: {
      // NOTE: Ant does not offer other way to customize translations in DatePicker, long names are according to design
      shortMonths: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
  },
} as Partial<Locale>) as Locale;
